var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        { staticClass: "operation" },
        [
          _c(
            "el-tabs",
            {
              staticClass: "tabName",
              on: { "tab-click": _vm.handleClick },
              model: {
                value: _vm.activeName,
                callback: function ($$v) {
                  _vm.activeName = $$v
                },
                expression: "activeName",
              },
            },
            [
              _c("el-tab-pane", { attrs: { label: "上传文档", name: "a" } }),
              _c("el-tab-pane", { attrs: { label: "粘贴文档", name: "b" } }),
            ],
            1
          ),
          _vm.activeName == "a"
            ? _c(
                "div",
                { staticClass: "batch-top" },
                [
                  _c(
                    "el-upload",
                    {
                      staticClass: "upload-demo",
                      attrs: {
                        drag: "",
                        action: _vm.action,
                        "file-list": _vm.fileList,
                        headers: _vm.headers,
                        limit: 2,
                        "on-change": _vm.onChange,
                        "on-success": _vm.success,
                        "before-upload": _vm.beforeUpload,
                      },
                    },
                    [
                      _c("img", {
                        attrs: {
                          src: require("@/assets/newicons/ib03.png"),
                          alt: "",
                        },
                      }),
                      _c("div", { staticClass: "div-text fl" }, [
                        _c("div", { staticClass: "el-upload__text" }, [
                          _vm._v("点击或将文件拖拽至此处"),
                          _c(
                            "span",
                            {
                              staticClass: "file-name",
                              on: {
                                click: function ($event) {
                                  $event.stopPropagation()
                                  return _vm.clickDownload.apply(
                                    null,
                                    arguments
                                  )
                                },
                              },
                            },
                            [_vm._v("下载模板.xls")]
                          ),
                        ]),
                        _c(
                          "div",
                          {
                            staticClass: "el-upload__tip",
                            attrs: { slot: "tip" },
                            slot: "tip",
                          },
                          [
                            _vm._v(
                              "1. 下载模版并填充企业全称信息； 2. 上传文件不超过2M，仅支持Excel（xls、xlsx）文件； 3. 单次查询企业数量不能超过200家。"
                            ),
                          ]
                        ),
                      ]),
                    ]
                  ),
                  _vm.fileList.length > 0
                    ? _c("div", { staticClass: "hint-file" }, [
                        _c("div", { staticClass: "ll" }, [
                          _c("img", {
                            attrs: {
                              src: require("@/assets/newicons/sn01.png"),
                              alt: "",
                            },
                          }),
                          _c(
                            "span",
                            {
                              staticStyle: {
                                "font-size": "14px",
                                "font-weight": "400",
                                color: "#999999",
                                "line-height": "20px",
                              },
                            },
                            [_vm._v(_vm._s(_vm.fileList[0]["name"]) + " ")]
                          ),
                        ]),
                        _vm._m(0),
                      ])
                    : _vm._e(),
                ],
                1
              )
            : _vm._e(),
          _vm.activeName == "b"
            ? _c(
                "div",
                { staticClass: "post-txt" },
                [
                  _c("el-input", {
                    attrs: {
                      type: "textarea",
                      rows: 5,
                      placeholder:
                        "例如：" +
                        "\n" +
                        "珍岛信息技术(上海)股份有限公司" +
                        "\n" +
                        "珍岛信息技术(上海)股份有限公司" +
                        "\n" +
                        "珍岛信息技术(上海)股份有限公司",
                      maxlength: "3000",
                      "show-word-limit": "",
                    },
                    model: {
                      value: _vm.postTxt,
                      callback: function ($$v) {
                        _vm.postTxt = $$v
                      },
                      expression: "postTxt",
                    },
                  }),
                  _c(
                    "el-button",
                    {
                      staticStyle: { "margin-top": "20px", float: "right" },
                      attrs: { type: "dialog-confirm", disabled: _vm.loading },
                      on: { click: _vm.matchCompany },
                    },
                    [_vm._v("匹配")]
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
      _c(
        "div",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          staticClass: "div-list",
        },
        [
          _c(
            "company-card-list",
            {
              ref: "cardlist",
              staticClass: "ccl",
              attrs: {
                companyType: 8,
                searchType: _vm.activeTab,
                batchActions: _vm.batchActions,
                list: _vm.list,
              },
              on: {
                "handle-page-num": _vm.handlePageNum,
                "handle-page": _vm.handlePage,
              },
            },
            [
              _c("div", { staticClass: "searchBar" }, [
                _c("span", { staticClass: "font-15-md" }, [
                  _vm._v("小T为您找到 "),
                  _c(
                    "span",
                    {
                      staticClass: "blueColor",
                      staticStyle: { color: "#5088FF" },
                    },
                    [_vm._v(_vm._s(_vm._totalElements))]
                  ),
                  _vm._v(" 家企业资源"),
                ]),
              ]),
            ]
          ),
        ],
        1
      ),
      _c("Robot"),
      _c("right-float", { ref: "rightFloat", attrs: { globalRfType: true } }),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "rr" }, [
      _c("img", {
        staticStyle: { width: "20px" },
        attrs: { src: require("@/assets/newicons/sn02.png"), alt: "" },
      }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }